/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  GetApiV1IndividualpaymentSharedParcelEnumsQueryResponse,
  GetApiV1IndividualpaymentSharedParcelEnumsQueryParams,
  GetApiV1IndividualpaymentSharedParcelEnums401,
  GetApiV1IndividualpaymentSharedParcelEnums500,
} from "../../types/individualPaymentSharedController/GetApiV1IndividualpaymentSharedParcelEnums.ts";

function getGetApiV1IndividualpaymentSharedParcelEnumsUrl() {
  const res = {
    method: "GET",
    url: `/api/v1/individualpayment/shared/parcel-enums` as const,
  };
  return res;
}

/**
 * @description Retorna em uma única chamada as listas { key, value } dos enums usados no fluxo de parcela, com rótulo traduzido na cultura informada: 'types' (ETypePayment → campo 'typeId'), 'statuses' (EStatusPayment → campo 'statusId', inclui WaitingIntegration = 0), 'gridStatuses' (EFinancialGridParcelStatus → campo 'status' da grid, calculado a partir do status e do vencimento), 'paymentMethods' (EPaymentMethod completo → campo 'paymentMethod'), 'invoiceStatuses' (EStatusEnotas → 'status' de parcels/{id}/invoices) e 'transferTypes' (ETransferType). Atenção: em 'types', Registration (1) e Enrollment (2) compartilham o rótulo "Inscrição" desde o legado — as duas chaves são devolvidas porque ambas são valores válidos de 'typeId'. Para o dropdown restrito a boleto/cartão do plano use 'shared/payment-types'. Substitui as actions do EnumAsyncController do legado. **(Requer Authorization para autenticação)**
 * @summary Enums do fluxo de parcela (tipo, status, método de pagamento, status da NFe) (Requer Authorization para autenticação)
 * {@link /api/v1/individualpayment/shared/parcel-enums}
 */
export async function getApiV1IndividualpaymentSharedParcelEnums(
  params?: GetApiV1IndividualpaymentSharedParcelEnumsQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiV1IndividualpaymentSharedParcelEnumsQueryResponse,
    ResponseErrorConfig<
      | GetApiV1IndividualpaymentSharedParcelEnums401
      | GetApiV1IndividualpaymentSharedParcelEnums500
    >,
    unknown
  >({
    method: "GET",
    url: getGetApiV1IndividualpaymentSharedParcelEnumsUrl().url.toString(),
    params,
    ...requestConfig,
  });
  return res.data;
}
